(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TwoFactorController',TwoFactorController);

    TwoFactorController.$inject = ['$state', '$uibModalInstance', 'pagingParams', 'AlertService', 'User'];

    function TwoFactorController($state, $uibModalInstance, pagingParams, AlertService, User) {
        var vm = this;
        vm.qrCode2Factor = pagingParams.result.qrCode2Factor;
        vm.privateKey = pagingParams.result.privateKey;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.copyKey = function () {
            navigator.clipboard.writeText(vm.privateKey);
            AlertService.success("settings.twoFactor.copySuccess");
        }

        vm.confirm = function () {
            User.set2FEmail({twoFactorEmail: false});
            $uibModalInstance.close(true);
        }
    }
})();
